/**
 * monetization/query-keys — factoría de claves TanStack Query del kit.
 * Mismo contrato que `utils/query-keys.ts`: nunca arrays inline en el call site.
 */

export const billingQueryKeys = {
  all: ["billing"] as const,
  config: () => ["billing", "config"] as const,
  usage: () => ["billing", "usage"] as const,
  adminConfig: () => ["admin", "monetization"] as const,
};
